/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/** Open external links in the header and footer in a new tab */
function handleExternalLinks() {
    var links = document.querySelectorAll(".Header__MainNav a,.SidebarMenu a,.Footer a,.CollectionList--teamOnix a");
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].relList.add('noreferrer', 'noopener');
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    handleExternalLinks();
})

let searchBtn = document.querySelector('a[data-action="toggle-search"]');
let headerContainer = document.querySelector('.Header__MainNav ');
let headerWrapper = document.querySelector('#section-header');
let searchClose = document.querySelector('.Search__Close');

searchBtn.addEventListener('click', () => {
  setTimeout(() => {
    let searchModal = document.querySelector('.PageOverlay');
    if (searchModal.classList.contains('is-visible')) {
     headerContainer.classList.add('open-search')
     headerWrapper.classList.add('open-search-header')
    } else {
     headerContainer.classList.remove('open-search')
     headerWrapper.classList.remove('open-search-header')
    }
  }, 50);
})

searchClose.addEventListener('click', () => {
  setTimeout(() => {
    let searchModal = document.querySelector('.PageOverlay');
    if (searchModal.classList.contains('is-visible')) {
     headerContainer.classList.add('open-search')
     headerWrapper.classList.add('open-search-header')
    } else {
     headerContainer.classList.remove('open-search')
     headerWrapper.classList.remove('open-search-header')
    }
  }, 50);
})




